export const scrollToFirstError = (containerEl) => {
    containerEl.querySelector("[class*=--invalid]").scrollIntoView({
        behavior: "smooth",
        block: "center",
    });
};
